// Typed helpers for the Answer library (/api/answers). Pure URL builders.
import type { SavedAnswerResult, SavedAnswerView } from "@shared/api";
import { api } from "./api";

const enc = encodeURIComponent;

export const answersUrls = {
  list: (q?: string) => `/api/answers${q?.trim() ? `?q=${enc(q.trim())}` : ""}`,
  save: () => "/api/answers",
  answer: (id: string) => `/api/answers/${enc(id)}`,
  restore: (id: string) => `/api/answers/${enc(id)}/restore`,
};

export const answersApi = {
  list: (q?: string, signal?: AbortSignal) =>
    api<SavedAnswerView[]>(answersUrls.list(q), { signal }),
  /** Saves the research answer on a card; saving it again returns the copy already kept. */
  saveFromCard: (cardId: string) =>
    api<SavedAnswerResult>(answersUrls.save(), { method: "POST", body: { cardId } }),
  rename: (id: string, title: string) =>
    api<SavedAnswerView>(answersUrls.answer(id), { method: "PATCH", body: { title } }),
  /** An answer in the owner's own words (a snippet; U13). */
  write: (title: string, answer: string) =>
    api<SavedAnswerView>("/api/answers/written", { method: "POST", body: { title, answer } }),
  /** Title and text of an answer the owner wrote (research answers keep their text). */
  edit: (id: string, patch: { title: string; answer: string }) =>
    api<SavedAnswerView>(answersUrls.answer(id), { method: "PATCH", body: patch }),
  remove: (id: string) => api<SavedAnswerView>(answersUrls.answer(id), { method: "DELETE" }),
  restore: (id: string) => api<SavedAnswerView>(answersUrls.restore(id), { method: "POST" }),
};
